import { get } from "../../../logics/src/utils/helpers";
import { customerVpaListTransformer } from './customerVpaListTransformer';
import { downBankListTransformer } from './downBankListTransformer';
import { bankListTransformer } from './bankListTransformer';
import { savedCardDtoListTransformer } from './savedCardDtoListTransformer';
import { convertArrayToHashMap } from 'layouts/Payment/common/dependencies/dependencyhelpers';
import { PAYMENT_GATEWAYS } from 'shared/constants/paymentGateways';

/**
 *
 * @param response last_payment_info from getInfoPaymentCreation api response.
 * @returns transformed lastpaymentInfo, excludes last payment info data in case of cashfree_payment_gateway pg.
 * As we don't support saved cashfree payment gateway.
 */
const lastPaymentInfoTransformer = (response: { paymentGateway: string }) => {
  const paymentGateway = get(response, "paymentGateway");

  if (paymentGateway && paymentGateway == PAYMENT_GATEWAYS.CASH_FREE_SEAMLESS) {
    return {};
  }
  return response;
};

const sortOnTheBasisOfName = (a: any, b: any) => {
  const nameA = a.name.toUpperCase(); // ignore upper and lowercase
  const nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};

export const paymentCreationInfoTransformer = (response: any) => {
  // Sorting netBanking. REFERENCE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
  // This sorts inplace, so no need to re-assign.
  if (response.net_banking_list) {
    response.net_banking_list.sort(sortOnTheBasisOfName);
  }

    return {
      isBinHashValidationRequired: response.isBinHashValidationRequired || false,
      isBinValidationRequired: response.isBinValidationRequired || false,
      cacheTimeForDevices: response.cacheTimeForDevices || [],
      customerVpaList: customerVpaListTransformer(response.customer_vpa_list || []),
      downBankList: downBankListTransformer(response.down_bank_list || []),
      isPaytmUser: response.is_paytm_user || false,
      lastPaymentInfo: lastPaymentInfoTransformer(response.last_payment_info) || {},
      netBankingList: bankListTransformer(response.net_banking_list || []),
      paymentExtraParamsMap: response.paymentExtraParamsMap,
      paytmUser: response.paytmUser || false,
      pgSelectionDTO: response.pgSelectionDTO || {},
      razorpayInfoDTO: response.razorpayInfoDTO || {},
      savedCardDTOList: savedCardDtoListTransformer(response.savedCardDTOList || []),
      zest: response.zest || {},
      simplDTO: response.simplDTO || {},
      supportPaytmWebFlow: response.support_paytm_web_flow || false,
      timeOfStorage: +new Date(),
      paymentAlertInfo: convertArrayToHashMap(response.payment_alert || [], 'mode'),
      paytmUserDTO: response.paytmUserDTO || {},
      /**
       * nudge object having either with null value or having properties imageIcon, ctaText, ctaClickable, mode and 
       * messages(object with text and boldText property)
       * All values will be of type string except ctaClicable(boolean)
       */
      nudge: response.nudge || {},
      token: response.token || "",
      tokenExpiry: response.tokenExpiry || null,
      sessionRefId: response.sessionRefId || "",
      isCardS2SFlowEnabled: response.isCardS2SFlowEnabled || false,
      credDetailsDTO: response.credDetailsDTO || {},
      fallbackModes: response.fallbackModes || null,
      customerId: response.customerId || '',
    };
    
};
